const plugin = {
  install: (Vue, options) => {
    const insertScript = () => {
      window._hmt = [];
      window._hmt.push(['_setAutoPageview', false]);
      // window._hmt.push(['_setAutoTracking', false]);
      // console.log('window._hmt', window._hmt)

      (function() {
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?f97175c1d499c86b24e5f481264d10e2";
        var s = document.getElementsByTagName("script")[0];
        // hm.setAttribute('async', true)
        s.parentNode.insertBefore(hm, s);
      })();
    }

    const Baidu = {
      page (path) {
        if (!window._hmt) {
          insertScript()
        // } else if (window._hmt && _hmt.push) {
        }
        console.log('bd_track', path)
        window._hmt.push(['_trackPageview', path]);
      },
      event (category, action, opt_label, opt_value) {
        if (window._hmt && _hmt.push) {
          window._hmt.push(['_trackEvent', category, action, opt_label, opt_value])
        }
      }
    }

    // 添加到全局
    window.$baidu = Vue.$baidu = Baidu
    // 添加到实例
    Vue.prototype.$baidu = Baidu

    /**
     * 通过在dom上放入data-baidu属性来发送event
     *
     * 举例：
     * <a href="xx" data-baidu="类别|操作|label|value"></a>
     * 即会触发：_hmt.push(['_trackEvent','类别','操作', 'label', 'value'])
     */
    document.body.addEventListener('click', (event) => {
      let target = event.target
      let datastr = target.getAttribute('data-baidu')

      if (!datastr && target.parentNode) {
        target = target.parentNode
        datastr = target.getAttribute('data-baidu')

        if (!datastr && target.parentNode) {
          target = target.parentNode
          if (target.getAttribute) {
            datastr = target.getAttribute('data-baidu')
          }
        }
      }

      if (datastr) {
        let data = datastr.split('|')
        if (data && data.length > 1 && window._hmt) {
          window._hmt.push(['_trackEvent'].concat(data))
        }
      }

    }, false)
  }
}

export default plugin



// WEBPACK FOOTER //
// ./src/plugins/BaiduAnalysis.js